// Actual domain logic should be in a domainLogic.js file, at the appropriate
// level in the hierarchy.
import { IN_TRANSACTION } from "appConfig";

import { Decimal, Money } from "classes/DecimalClasses";

import {
  changeCustomer,
  updateLineItemAvailable,
} from "services/sosInventoryService/salesTransaction/domainLogic";
import { getRecord } from "services/sosInventoryService/sosApi";
import { handleProgramError } from "services/utility/errors";

export async function updateTransaction(
  field,
  newValue,
  transactionCustomFieldDefs,
  customerCustomFieldDefs,
  currentState,
  taxCodes,
  updaters,
  currencies
) {
  const { record, lines, relatedRecords } = currentState;
  if (!record || !lines || !relatedRecords) {
    handleProgramError(new Error("update Transaction | invalid currentState"));
  }

  let newRecord, newLines, newRelatedRecords;

  switch (field) {
    case "date":
      newRecord = { ...record, date: newValue, dateChanged: true };
      updaters.setRecord(newRecord);
      if (newValue) {
        newLines = await updateLineItemAvailable(newRecord, lines);
      }
      break;

    case "acceptedBy":
    case "acceptedDate":
    case "billing":
    case "channel":
    case "comment":
    case "customerMessage":
    case "customerNotes":
    case "customFields":
    case "department":
    case "expiration":
    case "number":
    case "priceTier":
    case "salesRep":
    case "shipping":
    case "status":
    case "transactionLocationQuickBooks":
      newRecord = { ...record, [field]: newValue };
      updaters.setRecord(newRecord);
      break;

    case "exchangeRate":
      newRecord = { ...record, [field]: new Decimal(newValue || 0) };
      updaters.setRecord(newRecord);
      break;

    case "shippingAmount":
      newRecord = {
        ...record,
        shippingAmount: new Money(newValue || 0),
        shippingUpdated: true,
      };
      updaters.setRecord(newRecord);
      break;

    case "customer":
      if (!newValue) {
        newRecord = { ...record, customer: null };
        updaters.setRecord(newRecord);
        newRelatedRecords = { ...relatedRecords, customer: null };
        break;
      }

      const recordData = await changeCustomer(newValue.id, {
        record,
        customerCustomFieldDefs,
        transactionCustomFieldDefs,
        transactionCustomFields: record.customFields,
        lines,
        taxCodes,
      });

      const priceTier = recordData.customer?.priceTier
        ? await getRecord(
            "pricetier",
            recordData.customer.priceTier.id,
            IN_TRANSACTION
          )
        : null;
      updaters.setRecord({ ...recordData.newRecord, priceTier });
      newLines = recordData.newLines;
      newRelatedRecords = { ...relatedRecords, customer: recordData.customer };

      break;

    case "currency":
      updaters.setRecord((prev) => ({
        ...prev,
        currency: newValue.id ? { id: newValue.id, name: newValue.name } : null,
        exchangeRate: newValue.id
          ? currencies.find(({ id }) => id === newValue.id).exchangeRate
          : null,
      }));
      break;

    default:
      handleProgramError(
        new Error(`updateTransaction | unknown field (${field})`)
      );
  }

  if (newLines) {
    updaters.lineHandler({ type: "set", lines: newLines });
  }
  if (newRelatedRecords) {
    updaters.setRelatedRecords(newRelatedRecords);
  }
}
